var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "edit-block", staticStyle: { "min-height": "1px" } },
    [
      _vm.block.content * 1
        ? _c(
            "div",
            {
              staticClass: "post-full-img",
              class: {
                pfileft: _vm.block.prefix == "left",
                pfiright: _vm.block.prefix == "right"
              }
            },
            [
              _vm.isPhoto(_vm.block.media)
                ? _c("img", { attrs: { src: _vm.photoLink(_vm.block.media) } })
                : _c(
                    "a",
                    {
                      staticClass: "ext-link",
                      attrs: {
                        target: "_blank",
                        href: _vm.photoLink(_vm.block.media)
                      }
                    },
                    [
                      _vm._v(
                        "Download: " + _vm._s(_vm.fileName(_vm.block.media))
                      )
                    ]
                  )
            ]
          )
        : _c("div", { staticClass: "post-full-img add" }, [
            _c("div", { staticClass: "video-uploader" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("input", {
                ref: "filechooser",
                attrs: { type: "file" },
                on: { change: _vm.uploadFile }
              })
            ])
          ]),
      _vm._v(" "),
      _c("a", { staticClass: "drag" }),
      _vm._v(" "),
      _c("a", {
        staticClass: "remove",
        on: {
          click: function($event) {
            return _vm.$emit("remove")
          }
        }
      }),
      _vm._v(" "),
      _vm.isPhoto(_vm.block.media)
        ? _c("a", {
            staticClass: "move mleft",
            on: {
              click: function($event) {
                _vm.block.prefix = "left"
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isPhoto(_vm.block.media)
        ? _c("a", {
            staticClass: "move mdefault",
            on: {
              click: function($event) {
                _vm.block.prefix = null
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isPhoto(_vm.block.media)
        ? _c("a", {
            staticClass: "move mright",
            on: {
              click: function($event) {
                _vm.block.prefix = "right"
              }
            }
          })
        : _vm._e()
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _vm._v("Drag and drop photo or file here "),
      _c("span"),
      _vm._v(" or click to select photo")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }